
import { LeaveFormData, LeaveType, TourPlanFormData, TourPlanType } from "../types/tourPlan";
import api from "./helper/client"
import { API_ROUTES } from "./helper/routes"


export const addTourPlan = async (data: TourPlanFormData[]) => {
    const response = await api.post(API_ROUTES.TOUR_PLAN, data);
    return response;
}

export const updateTourPlan = async (data: TourPlanType[]) => {
    console.log(data)
    const response = await api.put(API_ROUTES.TOUR_PLAN_UPDATE, data);
    console.log(response.data.data)
    return response;
}

export const getAllTourPlans = async (employee_id: number, tenant_id: number) => {
    const data = {
        "tenant_id": tenant_id,
        "employee_id": employee_id
    }
    const response = await api.post(API_ROUTES.TOUR_PLAN_BY_EMP, data)
    return response;
}

export const addTourPlanDeviation = async (tenantId: number, employeeId: number, tourPlanId: number, locationId: number, remarks: string) => {
    const data = {
        tenant_id: tenantId,
        employee_id: employeeId,
        tour_plan_id: tourPlanId,
        location_id: locationId,
        remarks: remarks
    }
    console.log(data);
    const response = await api.post(`${API_ROUTES.TOUR_PLAN}${API_ROUTES.DEVIATION}`, data);
    console.log(response.data.data)
    return response;
}

export const getAllLeaves = async (employee_id: number, tenant_id: number) => {
    const data = {
        "tenant_id": tenant_id,
        "employee_id": employee_id
    }
    console.log(data)

    const response = await api.post(API_ROUTES.LEAVES_BY_EMP, data)
    return response;
}

export const addLeave = async (data: LeaveFormData[]) => {
    const response = await api.post(API_ROUTES.LEAVE, data)
    return response;
}

export const updateLeave = async (data: LeaveType[]) => {
    console.log("data", data);
    const response = await api.put(API_ROUTES.LEAVE_UPDATE, data);
    console.log("response", response);
    return response;
}

export const updateTourPlanDeviation = async (tenant_id: number, tour_plan_id: number, deviation_id: number, status: string, approved_by: number) => {
    const data = {
        tenant_id: tenant_id,
        tour_plan_id: tour_plan_id,
        deviation_id: deviation_id,
        status: status,
        approved_by: approved_by
    }

    const response = await api.put(`${API_ROUTES.TOUR_PLAN}${API_ROUTES.DEVIATION}/update`, data);

    return response;
}

export const updateReschedule = async (
    tenantId: number,
    rescheduleId: number,
    status: "approved" | "rejected",
) => {
    const response = await api.put(`${API_ROUTES.TOUR_PLAN}/reschedule/update`, {
        tenant_id:     tenantId,
        reschedule_id: rescheduleId,
        status,
    });
    return response;
};

export const deleteTourPlan = async (id: number) => {
    const response = await api.delete(`${API_ROUTES.TOUR_PLAN}/${id}`);
    return response;
};

export const createSingleTourPlan = async (
    tenantId: number,
    employeeId: number,
    locationId: number,
    tourPlanDate: string,
    status: "draft" | "submitted" = "draft"
) => {
    const response = await api.post(API_ROUTES.TOUR_PLAN, [{
        tenant_id: tenantId,
        employee_id: employeeId,
        location_id: locationId,
        tour_plan_date: tourPlanDate,
        status,
    }]);
    return response;
};

export const updateSingleTourPlan = async (id: number, locationId: number, tenantId: number) => {
    const response = await api.put(`${API_ROUTES.TOUR_PLAN}/${id}`, {
        location_id: locationId,
        tenant_id: tenantId,
    });
    return response;
};

export const getLocationsByEmployee = async (employeeId: number) => {
    const data = {
        "employee_id": employeeId
    }
    const response = await api.post(API_ROUTES.LOCATION_BY_EMPLOYEE, data);
    return response;
}
